$ = require 'jquery'
Alerts = require 'views/lib/alerts'
LimitExceeded = require 'views/attachment/attachment-limit-exceeded-error'
limitExceededTemplate = require 'views/templates/popover_limit_exceeded'
parseURL = require 'url-parse'
Promise = require 'bluebird'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/card_attach_links'
xtend = require 'xtend'
track = require 'debug/track'
trackUe = require 'debug/trackUe'

module.exports = class CardAttachLinksView extends View
  initialize: ({ links }) ->
    @links = links

    @listenTo @model.attachmentList, 'add remove reset', @render

  viewTitleKey: 'attach links'

  events:
    'click .js-attach:not([disabled])': 'attach'

  render: ->
    if !@model.canAttach()
      if @model.isOverLimit('attachments', 'perCard')
        @$el.html(limitExceededTemplate('perCard'))
      else if @model.getBoard().isOverLimit('attachments', 'perBoard')
        @$el.html(limitExceededTemplate('perBoard'))

      return @

    entries = for link in @links
      xtend link,
        domain: parseURL(link.url).host
        attached: @model.attachmentList.any (att) ->
          att.get('url') == link.url

    @$el.html(template(entries))
    @

  attach: (e) ->
    $target = $(e.currentTarget)
    url = $target.attr('data-url')
    text = $target.attr('data-text')

    $target.attr('disabled', 'disabled')
    Promise.fromNode (next) => @model.uploadUrl({ url, name: text }, next)
    .then ->
      track("Attachment", "Upload link")
    .catch LimitExceeded, ->
      Alerts.show('unable to attach link', 'error', 'linkattachment', 5000)



// WEBPACK FOOTER //
// ./app/scripts/views/card/attach-links-view.coffee